// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-editor_textEditor__7nge9 .ql-editor {
  min-height: 120px;
}

.text-editor_textEditor__7nge9 [contenteditable="false"] {
  opacity: 1;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.38);
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/textEditor/text-editor.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,4CAA4C;AAC9C","sourcesContent":[".textEditor :global .ql-editor {\n  min-height: 120px;\n}\n\n.textEditor :global [contenteditable=\"false\"] {\n  opacity: 1;\n  -webkit-text-fill-color: rgba(0, 0, 0, 0.38);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textEditor": `text-editor_textEditor__7nge9`
};
export default ___CSS_LOADER_EXPORT___;
